const actions = {
  CHECKOUT_DETAILS_SET_DETAILS: "CHECKOUT_DETAILS_SET_DETAILS",
  CHECKOUT_DETAILS_RESET: "CHECKOUT_DETAILS_RESET",
  CHECKOUT_DETAILS_SET_KEY: "CHECKOUT_DETAILS_SET_KEY",
  SET_DETAILS_KEY: "SET_DETAILS_KEY",
}

export default actions;
